import { getChapterProgress, getGuideProgress, markChapterAsComplete } from '@api/guide';
import { getDatabases } from '@api/sandbox';

import { createQuery, useMutation } from '@lib/cache-query-client';

enum GuidePageQueryKey {
    GetDatabases = 'getDatabases',
    GetGuideProgress = 'getGuideProgress',
    GetChapterProgress = 'getChapterProgress',
    MarkAsCompleted = 'markAsCompleted',
}

const getDatabasesQuery = createQuery(GuidePageQueryKey.GetDatabases, () => [
    [GuidePageQueryKey.GetDatabases],
    async () => {
        const { data } = await getDatabases();

        return data;
    },
    { refetchOnWindowFocus: false },
]);

const getGuideProgressQuery = createQuery(GuidePageQueryKey.GetGuideProgress, () => [
    [GuidePageQueryKey.GetGuideProgress],
    async () => {
        const { data } = await getGuideProgress();

        return data;
    },
    { refetchOnWindowFocus: false },
]);

const getChapterProgressQuery = createQuery(
    GuidePageQueryKey.GetChapterProgress,
    (params: { chapterId: string; moduleId: string }) => [
        [GuidePageQueryKey.GetChapterProgress, params.moduleId, params.chapterId],
        async () => {
            const { data } = await getChapterProgress(params);

            return data;
        },
        { refetchOnWindowFocus: false },
    ],
);

const useMarkAsCompleted = () => {
    return useMutation(
        GuidePageQueryKey.MarkAsCompleted,
        (params: { moduleId: string; chapterId: string }) => {
            return markChapterAsComplete(params);
        },
    );
};

export {
    GuidePageQueryKey,
    getDatabasesQuery,
    getGuideProgressQuery,
    useMarkAsCompleted,
    getChapterProgressQuery,
};
